import { Controller } from '@hotwired/stimulus'
import { useMutation } from 'stimulus-use'

export default class extends Controller {
  static targets = ["row"]

  connect() {
    useMutation(this, { attributes: true, childList: true, subtree: true  });
    this.count();
  }

  count() {
    const visibleRowsCount = this.rowTargets.filter(el => el.offsetParent !== null).length;

    const countDisplay = document.getElementById("table-count");
    if (countDisplay) {
      countDisplay.textContent = visibleRowsCount;
    }
  }

  mutate(entries) {
    this.count();
  }
}